import longTermMaintenanceIcon from '../../../public/svg/icons/longTermMaintenance.svg';
import lowLatencyIcon from '../../../public/svg/icons/lowLatency.svg';
import rawPerformanceIcon from '../../../public/svg/icons/rawPerformance.svg';
import memorySafetyWithoutTheRuntimeCostIcon from '../../../public/svg/icons/whyRustForWeb/memorySafetyWithoutTheRuntimeCost.svg';

export const whenRustForWebData = [
  {
    title: 'Raw Performance',
    description: `Your application handles high request volumes or computationally intensive operations. Rust's zero-cost abstractions mean you get C++-level performance with modern language ergonomics.`,
    img: rawPerformanceIcon,
  },
  {
    title: 'Low Latency',
    description: `Microseconds matter. Trading systems, real-time analytics, gaming backends - if latency is critical, Rust delivers predictable, consistently fast response times.`,
    img: lowLatencyIcon,
  },
  {
    title: 'Memory Safety',
    description: `Your system handles sensitive data or runs in security-critical contexts. Rust eliminates entire categories of vulnerabilities that plague C and C++ applications.`,
    img: memorySafetyWithoutTheRuntimeCostIcon,
  },
  {
    title: 'Long-Term Maintenance',
    description: `Rust's type system catches bugs before they reach production. The code you write today will be easier to maintain and refactor years from now.`,
    img: longTermMaintenanceIcon,
  },
];
